module.exports = __webpack_public_path__ + "static/media/Bulk_deliver_update_file.ca7b5b2d.csv";